import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_attendance_details",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "info_update",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_attendance_details_button",
  "data-kt-drawer-close": "#kt_drawer_attendance_details_close",
  "data-kt-drawer-width": "70.5vw"
}
const _hoisted_2 = {
  id: "kt_info_update",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_info_update_header\"><h2 class=\"fw-bolder text-light my-auto\"> Trainee Attendance Information Update </h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_attendance_details_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_info_update_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_info_update_body",
  "data-kt-scroll-dependencies": "#kt_info_update_header, #kt_info_update_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_info_update_scroll"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Training Date")
], -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Attendance Date")
], -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Start Time ")
], -1)
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "End Time ")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "col-md-4 mt-5"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Lead Trainer")
], -1)
const _hoisted_19 = {
  key: 1,
  class: "col-md-4 mt-5"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Associate Trainer")
], -1)
const _hoisted_21 = {
  key: 2,
  class: "col-md-4 mt-5"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Guest Trainer")
], -1)
const _hoisted_23 = { class: "scroll-y row" }
const _hoisted_24 = { class: "table table-row-dashed table-row-gray-600 align-middle gs-0 gy-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-10px" }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-10px" }, "Photo"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-100px" }, "Reg. No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Present"),
    /*#__PURE__*/_createElementVNode("th", null, "Late"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Attendance Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "In Time"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Out Time"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Remarks")
  ])
], -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  class: "card-footer py-5 text-center",
  id: "kt_info_update_footer"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_drawer_attendance_details_close",
  class: "btn btn-danger me-5"
}, " Cancel ", -1)
const _hoisted_32 = ["data-kt-indicator"]
const _hoisted_33 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_34 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_35 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_date_picker, {
                        name: "training_date",
                        placeholder: "Training Date",
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        style: {"width":"100%"},
                        modelValue: _ctx.formData.training_date,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.training_date) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_el_date_picker, {
                        name: "training_date",
                        placeholder: "Training Date",
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        style: {"width":"100%"},
                        modelValue: _ctx.formData.attendance_date,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.attendance_date) = $event)),
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (this.setAttendanceDate(_ctx.formData.attendance_date)))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_el_time_picker, {
                        name: "start_time",
                        placeholder: "Start Time",
                        format: "hh:mm A",
                        "value-format": "hh:mm A",
                        modelValue: _ctx.formData.start_time,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.start_time) = $event)),
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (this.setInTime(_ctx.formData.start_time)))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_time_picker, {
                        name: "end_date",
                        placeholder: "End Time",
                        format: "hh:mm A",
                        "value-format": "hh:mm A",
                        modelValue: _ctx.formData.end_time,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.end_time) = $event)),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (this.setOutTime(_ctx.formData.end_time)))
                      }, null, 8, ["modelValue"])
                    ]),
                    (_ctx.class_type != 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Lead Trainer",
                            name: "lead_trainer",
                            filterable: "",
                            style: {"width":"100%"},
                            modelValue: _ctx.formData.lead_trainer,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.lead_trainer) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "",
                                label: "---Select---"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("---Select---")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.masterTrainerList, (info) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: info?.id,
                                  label: info?.employee_info?.name,
                                  value: info?.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info?.employee_info?.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.class_type != 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _hoisted_20,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Associate Trainer",
                            name: "associate_trainer",
                            filterable: "",
                            style: {"width":"100%"},
                            modelValue: _ctx.formData.associate_trainer,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.associate_trainer) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "",
                                label: "---Select---"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("---Select---")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associateTrainerList, (info) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: info?.id,
                                  label: info?.employee_info?.name,
                                  value: info?.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info?.employee_info?.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.class_type != 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _hoisted_22,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Guest Trainer",
                            name: "guest_trainer",
                            filterable: "",
                            style: {"width":"100%"},
                            modelValue: _ctx.formData.guest_trainer,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.guest_trainer) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "",
                                label: "---Select---"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("---Select---")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guestTrainerList, (info) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: info?.id,
                                  label: info?.employee_info?.name,
                                  value: info?.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info?.employee_info?.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("table", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traineeList, (data, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("img", {
                            style: {"width":"3.5vw"},
                            src: _ctx.api_url + data?.photo,
                            alt: ""
                          }, null, 8, _hoisted_26)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(data.registration_number), 1),
                        _createElementVNode("td", null, _toDisplayString(data.name), 1),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            checked: "",
                            type: "checkbox",
                            value: "1",
                            "onUpdate:modelValue": ($event: any) => ((data.is_present) = $event)
                          }, null, 8, _hoisted_27), [
                            [_vModelCheckbox, data.is_present]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: "1",
                            "onUpdate:modelValue": ($event: any) => ((data.is_late) = $event)
                          }, null, 8, _hoisted_28), [
                            [_vModelCheckbox, data.is_late]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_date_picker, {
                            name: "attendance_date",
                            placeholder: "Attendance Date",
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            style: {"width":"100%"},
                            modelValue: data.attendance_date,
                            "onUpdate:modelValue": ($event: any) => ((data.attendance_date) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_time_picker, {
                            modelValue: data.in_time,
                            "onUpdate:modelValue": ($event: any) => ((data.in_time) = $event),
                            name: "start_time",
                            placeholder: "In Time",
                            format: "hh:mm A",
                            "value-format": "hh:mm A",
                            style: {"width":"140px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_time_picker, {
                            modelValue: data.out_time,
                            "onUpdate:modelValue": ($event: any) => ((data.out_time) = $event),
                            name: "start_time",
                            placeholder: "Out Time",
                            format: "hh:mm A",
                            "value-format": "hh:mm A",
                            style: {"width":"140px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control form-control-sm text-right",
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((data.remarks) = $event)
                          }, null, 8, _hoisted_29), [
                            [_vModelText, data.remarks]
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmationBtn()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_34, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_36
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_32)
              ])), [
                [_directive_loading, _ctx.load]
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}